import React, { memo } from 'react';
import classnames from 'classnames/bind';
import { Text } from '@beef/ui-kit';
import { Picture } from '@beef/smart-kit';
import styles from "./styles.pcss";
var cn = classnames.bind(styles);
export var BaseLayout = /*#__PURE__*/memo(function (_ref) {
  var title = _ref.title,
    _ref$titleSize = _ref.titleSize,
    titleSize = _ref$titleSize === void 0 ? 'size2-m' : _ref$titleSize,
    _ref$titleColor = _ref.titleColor,
    titleColor = _ref$titleColor === void 0 ? 'grey95' : _ref$titleColor,
    text = _ref.text,
    _ref$textSize = _ref.textSize,
    textSize = _ref$textSize === void 0 ? 'size5-r-s' : _ref$textSize,
    _ref$textColor = _ref.textColor,
    textColor = _ref$textColor === void 0 ? 'grey60' : _ref$textColor,
    img = _ref.img,
    _ref$imgPosition = _ref.imgPosition,
    imgPosition = _ref$imgPosition === void 0 ? 'left' : _ref$imgPosition,
    classes = _ref.classes;
  return /*#__PURE__*/React.createElement("div", {
    className: cn('content', classes === null || classes === void 0 ? void 0 : classes.common),
    "data-t-id": "components-BaseLayout"
  }, img && /*#__PURE__*/React.createElement("div", {
    className: cn('image', "image--".concat(imgPosition))
  }, /*#__PURE__*/React.createElement(Picture, img)), /*#__PURE__*/React.createElement("div", {
    className: cn('texts')
  }, title && /*#__PURE__*/React.createElement(Text, {
    className: cn(classes === null || classes === void 0 ? void 0 : classes.title),
    color: titleColor,
    size: titleSize
  }, title), text && /*#__PURE__*/React.createElement(Text, {
    className: cn(classes === null || classes === void 0 ? void 0 : classes.text),
    color: textColor,
    size: textSize
  }, text)));
});